import React, { useEffect, useState } from "react"
import DropDownAction from "./DropDownAction"
import DataTable from "react-data-table-component"

import Application from "services/applications/Application.service"
import { Link } from "react-router-dom"


var appService = null

const Companies = props => {
  const [row_data, setrow_data] = useState()

  const fetchData = page => {
    props.paginate(page)
  }

  useEffect(() => {
    var rws = []
    let officer = ""

    appService = new Application(props.user)
    
    props.data.data.forEach(app => {
      rws.push({
        name: app.name,
        tin: app.tin,
        telephone: app.telephone,
        email: app.email,
        contact_person_name: app.contact_person_name,
        contact_person_phone: app.contact_person_phone,

        actions: (

            <Link to= {"/company/applications?id="+app.id}  className=" waves-effect">
                  <i className="ti-house"></i>
                  View Applications
                </Link>
//   <Link to={`/company/applications/${app.id}`}>
//   <i className="ti-eye" title="View Applications"></i>
// </Link>
        ),
      })
      setrow_data(rws)
    })
  }, [props.data])

  // Serverside pagination
  const columns = [
    {
      name: "Name",
      selector: "name",
    },
    {
      name: "TIN",
      selector: "tin",
    },
    {
      name: "Telephone",
      selector: "telephone",
    },
    {
      name: "Email",
      selector: "email",
    },
    {
        name:"Contact Person",
        selector: "contact_person_name"
    },
    {
        name:"Contact Person Phone",
        selector: "contact_person_phone"
    },
    {
      name: "Actions",
      selector: "actions",
    },
  ]

  return (
    <DataTable
      columns={columns}
      data={row_data}
      highlightOnHover
      pagination
      paginationServer
      paginationTotalRows={props.data.total}
      paginationPerPage={props.data.per_page}
      paginationComponentOptions={{
        noRowsPerPage: true,
      }}
      onChangePage={page => fetchData(page)}
    />
  )
}

export default Companies